import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import Clarity from '@microsoft/clarity';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

// Microsoft Clarity(行為分析 / session 錄影)。
// 專案 ID 在 clarity.microsoft.com 建專案後 Settings → Overview 取得,不是機密(本來就會出現在網頁原始碼)。
// 放在這裡而不是 environment.ts:那三個檔案(environment.ts / environment.prod.ts / proxy.conf.json)
// 本機有各自的改動且不進 commit,ID 擺進去會跟著漏掉。
//
// 只在正式 build 啟用:本機 ng serve 走 environment.ts(production=false),開發操作不會被送出去。
// ID 空字串時整段跳過,所以就算誤 build 也不會送出任何資料。
//
// ⚠ 部署前務必到 Clarity 後台把 Settings → Masking 設成 Strict。
//    預設的 Balanced 只遮輸入框,不遮頁面文字,而本後台的列表會把手機號 / 鑽石數 /
//    內部備註 memo / 封鎖原因直接印在畫面上,等於連同 session 錄影一起送到 Microsoft。
//    個別元素要加強遮蔽可加 data-clarity-mask="true"。
const CLARITY_PROJECT_ID = 'yat5tf7mx7';

if (environment.production) {
  enableProdMode();

  if (CLARITY_PROJECT_ID) {
    Clarity.init(CLARITY_PROJECT_ID);
  }
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
